import { TooltipPopper } from './TooltipPopper';

// TODO: in v9, move styled() from TooltipPopper.jsx to here
export var StyledTooltipPopper = TooltipPopper;